<template>
  <form @submit.prevent="submit" class="custom-form">
    <div class="row">
      <div class="col-md-6">
        <z-input
          v-model="password"
          name="password"
          label="Password"
          type="password"
          validate="required"
          autocomplete="password-1"
          @keyup="saveIt"
          @blur="verifyIt"
        />
      </div>
      <div class="col-md-6"></div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <z-input
          v-model="password2"
          name="password2"
          label="Confirm"
          type="password"
          validate="required"
          autocomplete="password-2"
          @keyup="saveIt"
          @blur="verifyIt"
        />
      </div>
      <div class="col-md-6">
        <button
          class="btn btn-sm btn-secondary mt-4"
          :class="{ 'btn-danger': isEdit }"
          v-if="!isAdd"
          @click="updatePassword"
        >
          Update Password
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <span v-if="message !== ''" class="custom-notice">{{ message }}</span>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import ZInput from '@/Components/ZElements/Input'
export default {
  name: 'user-password',
  components: {
    ZInput,
  },
  props: {
    isAdd: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      message: '',
      isEdit: false,
    }
  },
  emits: ['saveIt'],
  mounted() {
    this.isEdit = false
  },
  computed: {
    ...mapGetters('users', ['user']),
    password: {
      get() {
        let _data = ''
        if (this.user) {
          _data = this.user.detail.password
        }
        return _data
      },
      set(value) {
        this.setUserData({
          name: 'password',
          value: value,
        })
      },
    },
    password2: {
      get() {
        let _data = ''
        if (this.user) {
          _data = this.user.detail.password2
        }
        return _data
      },
      set(value) {
        this.setUserData({
          name: 'password2',
          value: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('users', ['setUserData', 'savePassword']),
    saveIt() {
      this.isEdit = true
      if (this.isAdd) {
        this.$emit('saveIt')
      }
      this.verifyIt()
    },
    verifyIt(data) {
      this.message = ''
      if (this.user.detail.password === '') {
        this.message = 'password missing'
      } else if (this.user.detail.password2 === '') {
        this.message = 'confirm password missing'
      } else if (this.user.detail.password !== this.user.detail.password2) {
        this.message = `passwords don't match`
      }
      if (!this.isAdd) {
        if (
          this.user.detail.password === '' &&
          this.user.detail.password2 === ''
        ) {
          this.message = ''
          this.isEdit = false
        }
      }
    },
    async updatePassword() {
      this.message = ''
      this.verifyIt()
      if (this.message === '') {
        if (
          this.user.detail.password !== '' &&
          this.user.detail.password2 !== ''
        ) {
          let password = {
            user_id: this.user.detail.id,
            password: this.user.detail.password,
          }
          await this.savePassword(password)
          this.message = ''
          this.isEdit = false
        }
      }
    },
  },
}
</script>
<style scoped>
.custom-form {
  min-height: 400px;
}
.custom-notice {
  color: red;
  font-weight: 500;
}
</style>
